import getYear from '@/utils/getYear';

import { ExtendedCarItem } from '../types';

const getCarDescription = (extendedData: ExtendedCarItem): string => {
  const { version, productionDate } = extendedData.data;
  if (version?.displayName) {
    const year = getYear(productionDate);
    return `${version.displayName}${year ? `,\u00A0${year}` : ''}`;
  }
  return '';
};

export default getCarDescription;
